import { render, staticRenderFns } from "./NewNode.vue?vue&type=template&id=0947922b&scoped=true"
import script from "./NewNode.vue?vue&type=script&lang=js"
export * from "./NewNode.vue?vue&type=script&lang=js"
import style0 from "./NewNode.vue?vue&type=style&index=0&id=0947922b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947922b",
  null
  
)

export default component.exports